import PropTypes from "prop-types";
import { Sparkles } from "lucide-react";
import { getOnboardingStepLabel } from "@/lib/onboardingSteps";

export function OnboardingStepBadge({ stepId }) {
  const label = getOnboardingStepLabel(stepId);
  if (!label) return null;
  return (
    <div className="text-[10.5px] uppercase tracking-wider text-indigo-700 font-semibold inline-flex items-center gap-1">
      <Sparkles size={11} /> Step {label.index} of {label.total}
    </div>
  );
}

OnboardingStepBadge.propTypes = {
  stepId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
